import React from 'react';

const Testimonials = () => {
    const testimonialsData = [
        {
            review: "Dinesh Builders is one of the best in the Chromepet area. They are professional, punctual, and deliver high-quality work. The team is skilled, and their attention to detail is impressive. Highly recommended for anyone looking for reliable builders.",
            stars: 5,
            name: "Ravi Kumar"
        },
        {
            review: "Had a great experience with Dinesh Builders. They maintain excellent communication throughout the project and ensure customer satisfaction. Their team is very experienced, and the final work exceeded our expectations. Would definitely choose them again.",
            stars: 5,
            name: "Priya Suresh"
        },
        {
            review: "Fantastic builder with a strong reputation in Chromepet. Dinesh Builders offers quality construction and delivers projects on time. Their workers are skilled, and the owner is very approachable. Highly trustworthy and professional service.",
            stars: 5,
            name: "Arun Prakash"
        },
        {
            review: "Dinesh Builders did an amazing job on our home renovation. The materials used were of great quality, and the workmanship was top-notch. The team was very cooperative and completed the project as promised. Absolutely satisfied with their service.",
            stars: 5,
            name: "Swathi Ramesh"
        }
    ];

    return (
        <div className='testimonials'>
            <div className='testimonials-title'>
                <span>Testimonials</span>
            </div>
            <div className='testimonials-content'>
            Our customers love the quality, professionalism, and dedication we bring to every project. Here's what they have to say about us
            </div>
            <div className='testimonial-cards-container'>
                {testimonialsData.map((testimonial, index) => (
                    <TestimonialsCard
                        key={index}
                        review={testimonial.review}
                        stars={testimonial.stars}
                        name={testimonial.name}
                    />
                ))}
            </div>
        </div>
    );
};

export default Testimonials;

interface TestimonialsCardProps {
    review: string;
    stars: number;
    name: string;
}

const TestimonialsCard: React.FC<TestimonialsCardProps> = ({ review, stars, name }) => {
    return (
        <div className='testimonialCard'>
            <div className='testimonial-review'>
                {review}
            </div>
            <div className='testimonial-card-contents'>
                <div className='testimonial-stars'>
                    {Array.from({ length: stars }, (_, i) => (
                        <span key={i}>&#9733;</span>
                    ))}
                </div>
                <div className='testimonal-reviewer-name'>
                    {name}
                </div>

            </div>
        </div>
    )
}